import Pagination, { PaginationProps } from '@mui/material/Pagination';
import PaginationItem, { PaginationItemProps } from '@mui/material/PaginationItem';

export function BasePagination({ ...otherProps }: PaginationProps) {
  return <Pagination {...otherProps} />;
}
export function BasePaginationItem({ ...otherProps }: PaginationItemProps) {
  return <PaginationItem {...otherProps} />;
}
